export default __webpack_public_path__ + "f7d05955c6b80faf506bee1d18567098.png";